var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol _gap-2" },
    [
      _c("p", { attrs: { "data-qa": "follow-success" } }, [
        _vm._v(
          _vm._s(
            _vm.Resources.Account.FollowProjectAsGuestSuccessModalDescription
          )
        ),
      ]),
      _vm._v(" "),
      _c(
        "base-button",
        {
          staticClass: "_as-fe",
          attrs: { "data-qa": "close" },
          on: { click: _vm.onClose },
        },
        [_vm._v(_vm._s(_vm.Resources.Common.ModalCloseButton))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }